import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  DeleteServiceCaller,
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import DeleteModal from "../../../../components/DeletePopUpComponent";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const PayrollScalesList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Payroll Scales"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [payrollScalesListData, setPayrollScalesListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);


  const payroll_type = { Name: "PayRoll type" }; // Example object
  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
  };

  useEffect(() => {
    fetchPayrollScalesList();
  }, []);

  const fetchPayrollScalesList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}payrolls/scales`);

      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
       setPayrollScalesListData(cleanedData?.map(item=> ({...item,CanDelete:0})));
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const handleEdit = (id) => {
  navigate(`/rujul/hrm/payroll-scales/edit/${id.ID}`);
  };

  const handleAddNewUser = () => {
    navigate(`/rujul/hrm/payroll-scales/add`);
  };


  // Open the initial delete modal
  const handleDeleteModal = (item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
  };

  // Close the delete modal and reset the state
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Proceed to confirmation modal
  const handleModalDelete = () => {
    setShowConfirmDeleteModal(true);
    setShowDeleteModal(false);
  };

  // Close the confirm delete modal
  const handleConfirmDeleteClose = () => {
    setShowConfirmDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Handle final delete action
  const handleConfirmModalDelete = async () => {
    if (selectedDeleteItem?.ID) {
      await handleDeleteRequest(selectedDeleteItem.ID);
    }
    setShowConfirmDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Perform the delete request

  const handleDeleteRequest = async (id) => {
    try {
      const response = await DeleteServiceCaller(
        `${API_URL}payrolls/scales/${id}`,
        {},
        "delete"
      );
        if (response?.status === 200) {
        fetchPayrollScalesList();
      } else if (response?.status === 201) {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 404) {
        const errorMessage =
          error?.response?.data?.message ||
          "An error occurred while deleting the item.";
        toast.error(errorMessage); // Display the error message using toast
      } else {
        toast.error("There was an error deleting the item."); // Fallback message
      }
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <Dynamic_PR_table
            data={payrollScalesListData}
            columns={columns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            isSrNoRequired={false}
            showIcon1={true}
            isSorting={true}
            showIcon2={true}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            showIcon3={false}
            showIcon4={false}
            showIcon5={false}
            handleIcon1={handleEdit}
            handleIcon2={handleDeleteModal}
            handleAddNew={handleAddNewUser}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square icons"></i>,
              Icon1Text: " Edit",
              Icon2: <i class="bi bi-trash-fill icons"></i>,
              Icon2Text: "Delete",
              Icon2Flag: "CanDelete",
              Icon3: <i class="bi bi-eye-fill icons"></i>,
              Icon4: <i class="bi bi-plus-square icons"></i>,
              Icon4Text: " Add Sub-Contractor",
            }}
          />
        </div>
      </div>

      {/** Delete Confirmation Popup */}
      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleModalDelete}
        message="Are you sure you want to delete this item?"
      />

      {/** Final Confirmation Popup */}
      <DeleteModal
        show={showConfirmDeleteModal}
        onClose={handleConfirmDeleteClose}
        onConfirm={handleConfirmModalDelete}
        message="Really you want to delete this item?"
      />
    </div>
  );
};

export default PayrollScalesList;
